import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0A1628] mt-24 mx-6 rounded-t-[32px] relative overflow-hidden">
      <div className="absolute bottom-0 left-0 right-0 text-white/[0.03] font-bold text-[120px] leading-none select-none pointer-events-none">
        BIOTRAUMA
      </div>

      <div className="max-w-7xl mx-auto px-8 py-20 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-orange rounded-lg flex items-center justify-center">
                <i className="ri-delete-bin-line text-white text-xl"></i>
              </div>
              <div className="flex flex-col">
                <span className="text-white font-bold text-lg leading-tight">BIOTRAUMA</span>
                <span className="text-orange text-xs font-semibold leading-tight">BARCELONA</span>
              </div>
            </div>
            <p className="text-white/80 text-lg leading-relaxed mb-8 max-w-[280px]">
              Especialistas en vaciado de pisos, locales y trasteros en Barcelona. Servicio profesional y discreto.
            </p>
            <a
              href="tel:+34629501941"
              className="inline-block bg-orange text-white px-6 py-2.5 rounded-full font-medium hover:bg-orange-light transition-colors whitespace-nowrap cursor-pointer"
            >
              Contactar ahora
            </a>
          </div>

          <div>
            <h3 className="text-lg font-bold text-navy mb-4">Servicios</h3>
            <ul className="space-y-2">
              <li>
                <a href="/servicios#vaciado-pisos-casas" className="text-gray-600 hover:text-orange transition-colors cursor-pointer">
                  Vaciado de pisos y casas
                </a>
              </li>
              <li>
                <a href="/servicios#vaciado-locales" className="text-gray-600 hover:text-orange transition-colors cursor-pointer">
                  Vaciado de locales comerciales
                </a>
              </li>
              <li>
                <a href="/servicios#vaciado-trasteros" className="text-gray-600 hover:text-orange transition-colors cursor-pointer">
                  Vaciado de trasteros
                </a>
              </li>
              <li>
                <a href="/servicios#retirada-muebles" className="text-gray-600 hover:text-orange transition-colors cursor-pointer">
                  Retirada de muebles
                </a>
              </li>
              <li>
                <a href="/servicios#limpieza-final" className="text-gray-600 hover:text-orange transition-colors cursor-pointer">
                  Limpieza final
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold text-navy mb-4">Empresa</h3>
            <ul className="space-y-2">
              <li>
                <a href="/empresa" className="text-gray-600 hover:text-orange transition-colors cursor-pointer">
                  Sobre nosotros
                </a>
              </li>
              <li>
                <a href="/empresa#valores" className="text-gray-600 hover:text-orange transition-colors cursor-pointer">
                  Nuestros valores
                </a>
              </li>
              <li>
                <a href="/faq" className="text-gray-600 hover:text-orange transition-colors cursor-pointer">
                  Preguntas frecuentes
                </a>
              </li>
              <li>
                <a href="/contacto" className="text-gray-600 hover:text-orange transition-colors cursor-pointer">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-base uppercase tracking-wider mb-5">
              Legal
            </h3>
            <ul className="space-y-3 mb-6">
              <li>
                <a href="#" className="text-white/70 hover:text-white hover:translate-x-1 transition-all inline-block cursor-pointer">
                  Aviso legal
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-white hover:translate-x-1 transition-all inline-block cursor-pointer">
                  Política de privacidad
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-white hover:translate-x-1 transition-all inline-block cursor-pointer">
                  Política de cookies
                </a>
              </li>
            </ul>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-orange transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-orange transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-orange transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold text-base uppercase tracking-wider mb-5">
              Contacto rápido
            </h3>
            <p className="text-white/70 text-sm mb-4">
              ¿Necesitas un presupuesto? Escríbenos tu email y te contactamos.
            </p>
            <div className="relative">
              <input
                type="email"
                placeholder="tu@email.com"
                className="w-full bg-white/10 border border-white/20 rounded-full px-5 py-3.5 text-white placeholder:text-white/50 focus:outline-none focus:border-orange"
              />
              <button
                className="absolute right-1 top-1 w-11 h-11 bg-orange rounded-full flex items-center justify-center text-white hover:bg-orange-light transition-colors cursor-pointer"
                aria-label="Enviar"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © 2025 BIOTRAUMA BARCELONA. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
